import React, { FC, useCallback, useState } from "react";

import Modal from "./Modal";
import { Button } from "../Base";
import { TransactionPostSans } from "../../Services/Transactions";
import { Toast } from "../../Utils";

interface ConfirmModalProps {
  onClose: () => void;
  onSubmit: () => void;
}

const CreateSansModal: FC<ConfirmModalProps> = ({ onClose, onSubmit }) => {
  const [day, setDay] = useState<string>("شنبه");
  const [startTimeMinuts, setStartTimeMinuts] = useState<string>("30");
  const [startTimeHour, setStartTimeHour] = useState<string>("12");
  const [endTimeMinuts, setEndTimeMinuts] = useState<string>("30");
  const [endTimeHour, setEndTimeHour] = useState<string>("12");

  const [loading, setLoading] = useState<boolean>(false);

  // ==================================================================================

  const hourChoices = Array.from({ length: 24 }, (_, index) =>
    (index + 1).toString()
  );
  const minutsChoices = Array.from({ length: 59 }, (_, index) =>
    (index + 1).toString()
  );
  const dayChoices = [
    "شنبه",
    "یکشنبه",
    "دوشنبه",
    "سه‌شنبه",
    "چهارشنبه",
    "پنجشنبه",
    "جمعه",
    "روزهای زوج",
    "روزهای فرد",
  ];

  // ==================================================================================

  const isValid = useCallback(() => {
    return (
      day && startTimeMinuts && startTimeHour && endTimeMinuts && endTimeHour
    );
  }, [day, startTimeMinuts, startTimeHour, endTimeMinuts, endTimeHour]);

  // ==================================================================================

  const handleSubmit = () => {
    if (isValid()) {
      setLoading(true);
      TransactionPostSans({
        day,
        start_time: `${startTimeHour}:${startTimeMinuts}`,
        end_time: `${endTimeHour}:${endTimeMinuts}`,
      })
        .then(({ data: res }) => {
          if (res.transaction_status) {
            Toast("success", res.message);
            onClose();
            onSubmit();
          } else {
            Toast("error", res.message);
          }
        })
        .finally(() => setLoading(false));
    }
  };

  // ==================================================================================
  return (
    <Modal close={onClose}>
      <div
        style={{ width: 520 }}
        className="p-3 z-3 bg-white flex flex-column justify-content-center align-items-center rounded-2 shadow"
      >
        <div className="mb-2 pb-3 pt-1 border-bottom d-flex justify-content-start  align-items-center gap-2">
          <i className="bi bi-plus-circle-fill text-primary fs-5 d-flex" />
          <p className="fw-bold m-0">افزودن سانس</p>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center gap-2 py-2">
          <select
            value={day}
            onChange={(e) => setDay(e.target.value)}
            className="cursor-pointer form-select"
          >
            {dayChoices.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </select>
          <div className="d-flex w-100 align-items-center justify-content-center gap-2">
            <div className="d-flex flex-grow-1 align-items-center justify-content-center gap-1">
              <select
                value={startTimeMinuts}
                onChange={(e) => setStartTimeMinuts(e.target.value)}
                className="cursor-pointer form-select"
              >
                <option value="00">00</option>

                {minutsChoices.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              :
              <select
                value={startTimeHour}
                onChange={(e) => setStartTimeHour(e.target.value)}
                className="cursor-pointer form-select"
              >
                <option value="00">00</option>
                {hourChoices.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <h6 className="mb-0">تا</h6>
            <div className="d-flex flex-grow-1 align-items-center justify-content-center gap-1">
              <select
                value={endTimeMinuts}
                onChange={(e) => setEndTimeMinuts(e.target.value)}
                className="cursor-pointer form-select"
              >
                <option value="00">00</option>

                {minutsChoices.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              :
              <select
                value={endTimeHour}
                onChange={(e) => setEndTimeHour(e.target.value)}
                className="cursor-pointer form-select"
              >
                <option value="00">00</option>

                {hourChoices.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <hr />
        <div className="d-flex justify-content-end gap-2 w-100 align-items-center">
          <Button
            btnClass="text-danger border border-danger w-25 mb-0"
            text="انصراف"
            onClick={onClose}
          />
          <Button
            btnClass="bg-primary text-white w-25 mb-0"
            text="ثبت"
            isLoading={loading}
            disabled={!isValid()}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CreateSansModal;
